module.exports = __webpack_public_path__ + "static/media/ar21_dplunkett.63e50f32.jpeg";